import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {

  
  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");   
    this.getDetail(1);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){       
      this.loading=true;
      this.service.GetApi('faq').subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this;  
          this.loading=false;
          this.dataListing=response.data;
          this.totalCount =response.data.length;
        } else {
          this.dataListing=[];
          this.totalCount =0;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    reset(){
      this.searchKey='';
      this.getDetail(1);
    }
  

    redirect(data:any ,type:any){
      if(type==1){
      localStorage.setItem('hva_faq',JSON.stringify(data));
      this.router.navigate(['/faq-update']);
      } else {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then((result:any) => {
          let statusType: number = 0;
          if (result.isConfirmed) {
            this.service.DeleteApi('faq/delete/' +data._id).subscribe(((response:any)=>{
              if(response.success ==1) {  
                var self =this;  
                this.loading=false;
                this.getDetail(1);              
              } else {
                this.service.dangerAlert(response.message);
                this.loading=false;
              }
            }), (error) => { this.loading =false; });
          }
        });
      }
    }
}
